<template>
    <div class="cabinet" v-if="idea.id" :class="'status_'+idea.status_id">

        <div class="cabinet-header">

            <router-link v-for="cat in getCategories()" :to="{ name: 'ideas-category', params: { category_id: cat.id}}" class="first-link-cabinet">
                {{ cat.title }}
            </router-link>
            
            <span v-if="dateToNow(idea.created) < 8" class="badge-new">Новая</span>
            <span v-if="idea.likes >= 50" class="badge-popular">Популярная</span>
            <span class="badge-status">{{ status }}</span>

            <span v-if="starrable" class="help-button" @click="toggleStarred(idea)" :class="{'active-help-button': idea.starred}" title="Добавить в избранное">
                <i class="ti-star"></i>
            </span>

            <span v-if="editable" class="help-button trash" @click="deleteIdea(idea)" title="Удалить">
                <i class="ti-trash"></i>
            </span>

            <router-link v-if="editable" :to="{ name: 'idea-edit', params: {id: idea.id}}" class="redact">
                <i class="ti-pencil" aria-hidden="true"></i>
            </router-link>

        </div>

        <h2 class="cabinet-title">
            <router-link :to="{ name: 'idea', params: {id: idea.id}}">
                {{idea.title}}
            </router-link>
        </h2>

        <p :class="['cabinet-text', !isItMyPage() ? 'cabinet-text-crop' : '']" v-html="idea.description"></p>

        <div class="moderator" v-if="idea.admin_note.comment && idea.admin_note && idea.admin_note.id">

            <span class="moderator-user">Модератор</span>

            <span class="moderator-name">{{idea.admin_name || idea.admin_note.user.name || ''}}</span>

            <span class="moderator-date">{{date(idea.admin_note.created)}}</span>

            <p class="moderator-text" v-html="idea.admin_note.comment"></p>
        </div>

        <div class="cabinet-footer">

            <div v-if="idea.status_id > 1"
                 class="cabinet-rates">
                <span class="button-like cabinet-buttons" @click="toggleLike(idea, 1)" :class="{ 'active-cabinet-buttons': idea.liked === 1}">
                    <i class="ti-thumb-up"></i> {{ idea.likes }}
                </span>

                <span class="button-dislike cabinet-buttons" @click="toggleLike(idea, 0)" :class="{ 'active-cabinet-buttons': idea.liked === 0}">
                    <i class="ti-thumb-down" aria-hidden="true"></i> {{ idea.dislikes }}
                </span>
            </div>
            
            <div class="cabinet-info">
                <div v-if="idea.status_id > 1"
                 class="cabinet-comments">
                    <router-link :to="{ name: 'idea', params: {id: idea.id}}">
                        <span class="comments">
                            {{ idea.comments }}
                        </span>
                        <span class="hide-mob">
                            {{ ' ' + numerable(idea.comments, ['комментарий', 'комментария', 'комментариев']) }}
                        </span>
                    </router-link>
                </div>

                <div class="cabinet-user user-name">
                    <a class="shortname"
                        v-if="idea.user"
                        :href="`https://amd.platformalp.ru/accounts/${idea.user.account_id}`"
                        target="_blank">
                        {{ idea.user.name ? `${idea.user.name},` : '' }}
                    </a> {{date(idea.created)}}
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    let statuses = {
        0: 'Отклонённая',
        1: 'На модерации',
        10: 'В работе',
        15: 'Реализованная'
    };

    export default {
        name: 'Idea',

        computed: {
            categories() {
                return this.$store.state.ideas.categories
            },
            status() {
                return statuses[this.idea.status_id];
            },
            editable() {
                return this.$store.getters['auth/isAdmin']
                    || ( this.$store.getters['auth/isLogged'] && this.idea.status_id === 1
                        && this.idea.user.id === this.$store.state.auth.user.id )
            },
            starrable() {
                return ( this.$store.getters['auth/isLogged'] )
            }
        },

        props: {
            idea: {
                required: true
            }
        },

        methods: {

            isItMyPage() {
               return this.idea.id == this.$store.state.ideas.currentIdeaId
            },

            getCategories() {
                let categories = [];
                if (this.idea.category_id) {
                    let cat = this.$store.state.ideas.categoriesById[this.idea.category_id];
                    categories.push(cat);

                    if (cat.parent_id) {
                        categories.push(this.$store.state.ideas.categoriesById[cat.parent_id]);
                    }
                }

                return categories.reverse();
            },

            getCategoryTitle(categoryId) {
                let cat = _.find(this.categories, {id: categoryId});
                return cat? cat.title : '';
            },

            toggleStarred(idea) {
                this.$store.dispatch('ideas/starredIdea', {
                    ideaId: idea.id,
                    starred: idea.starred ? 'unstar' : 'star'
                }).catch(console.error.bind(console));
            },

            deleteIdea(idea) {
                this.$confirm('Вы уверены, что хотите удалить идею?')
                    .$proxy(() => {
                        this.$store.dispatch('ideas/deleteIdea', {
                            ideaId: idea.id
                        })
                        .then(() => this.$emit('deleted'))
                        .catch(console.error.bind(console));
                    });
            },

            toggleLike(idea, likeOrNot) {

                if (!this.$store.getters['auth/isLogged']) {
                    this.$dialog('Необходимо авторизоваться, чтобы поставить оценку');
                    this.$router.push({ name: 'login' });
                    return false;
                }

                let actions = [];
                // нажали на лайк
                if (likeOrNot) {
                    // лайк уже есть
                    if (idea.liked === 1) {
                        actions = ['unlike'];
                        // уже есть дизлайк
                    } else if (idea.liked === 0) {
                        actions = ['undislike', 'like'];
                    } else {
                        actions = ['like'];
                    }

                    // нажали на дизлайк
                } else {
                    // дизлайн уже есть
                    if (idea.liked === 0) {
                        actions = ['undislike'];
                        // уже есть лайк
                    } else if (idea.liked === 1) {
                        actions = ['unlike', 'dislike'];
                    } else {
                        actions = ['dislike'];
                    }
                }
                this.$store.dispatch('ideas/toggleLike', {
                    ideaId: idea.id,
                    actions
                });
            },
        }
    }
</script>

<style lang="scss">

/*
    .cabinet-title:hover:before {
        content: 'e';
        position: absolute;
        background: #eee;
        width: 1em;
        left: -1em;
    }
*/

    .cabinet-header .first-link-cabinet:first-child {
        margin: 0 6px 0 0;
        vertical-align: middle;
    }
    .cabinet-header .first-link-cabinet:nth-child(2):before {
        color: #c9c9c9;
        content: '/';
        position: relative;
        left: -1em;
        font-weight: bold;
        vertical-align: middle
    }

    .cabinet-text {
        -webkit-hyphens: auto; -ms-hyphens: auto; hyphens: auto;  /* значение auto не поддерживается Chrome */
        line-break: auto;  /* нет поддержки для русского языка */
        word-wrap: break-word;
    }

    .cabinet-text-crop {
        max-height: 140px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .cabinet.status_1 {
        padding-bottom: 2em !important;
        color: #a1a1a1;

        .cabinet-title a {
           color: #a1a1a1;
        }

        .title-category {
            background-color: #f8bd13;
            right: -125px;

            &:before {
                border-color: transparent transparent #f8bd13 transparent;
            }
        }

        .badge-status {
            background-color: #f8bd13;
            color: #fff;
            border-radius: 3px;
            display: inline-block;
            margin: 0 6px;
            font-size: 12px;
            padding: 0 10px;
            line-height: 1.9;
            vertical-align: middle;
        }
    }

    .badge-new {
        background-color: #fe6f6f;
        color: #fff;
        border-radius: 3px;
        display: inline-block;
        margin: 0 6px;
        font-size: 12px;
        padding: 0 10px;
        line-height: 1.9;
        vertical-align: middle;
    }

    .badge-popular {
        background-color: #a97deb;
        color: #fff;
        border-radius: 3px;
        display: inline-block;
        margin: 0 6px;
        font-size: 12px;
        padding: 0 10px;
        line-height: 1.9;
        vertical-align: middle;
    }

    .status_10 {

        .title-category {
            background-color: #f8bd13;
            right: -115px;

            &:before {
                border-color: transparent transparent #f8bd13 transparent;
            }
        }

        .badge-status {
            background-color: #f8bd13;
            color: #fff;
            border-radius: 3px;
            display: inline-block;
            margin: 0 6px;
            font-size: 12px;
            padding: 0 10px;
            line-height: 1.9;
            vertical-align: middle;
        }
    }
    .status_15 {

        .title-category {
            background-color: #0dc76a;
            right: -115px;

            &:before {
                border-color: transparent transparent #0dc76a transparent;
            }
        }

        .badge-status {
            background-color: #0dc76a;
            color: #fff;
            border-radius: 3px;
            display: inline-block;
            margin: 0 6px;
            font-size: 12px;
            padding: 0 10px;
            line-height: 1.9;
            vertical-align: middle;
        }
    }

    .help-button {
        border: 0;
    }
    .help-button:hover {
        border: 0;
    }
    .trash {
        color: #ffb3b3;
        margin-right: 0.5em;
    }
    .trash:hover {
        color: red;
    }
</style>


// WEBPACK FOOTER //
// Idea.vue?ae01f674